carway = window.carway || {};

carway.buildUrl = function(url) {
	if (!moya.division) {
		return url;
	}
	return '/' + moya.division + url;
};

carway.search = {
	isMobile: function() {
		return ($(window).width() <= 960);
	},
	initForm: function() {
		this.initStationDropdown();
		this.initDatepicker();
		this.initTimepicker();
		//this.initClockpicker();
		this.initTrigger();
		this.initErrorHandling();
	},
	initTrigger: function() {
		var $trigger = $('.searchForm__trigger'),
			$form = $trigger.siblings('.searchForm');

		// Open form when an input has focus
		$form.find('input').on('focus', function() {
			open();
		});

		// Toggle form when trigger is clicked
		$trigger.on('click', function(e) {
			e.preventDefault();

			if ($form.hasClass('state--closed')) {
				open();
			}
			else {
				close();
			}
		});

		function open() {
			$('.box_carwaySearch .boxTitle').addClass('hidden');

			$form
				.removeClass('state--closed')
				.addClass('state--open')
				.addClass('animated slideDown');

			$trigger.find('.fa-angle-down').removeClass('fa-angle-down').addClass('fa-angle-up');
		}

		function close() {
			$('.box_carwaySearch .boxTitle').removeClass('hidden');

			$form
				.addClass('state--closed')
				.removeClass('state--open');

			$trigger.find('.fa-angle-up').removeClass('fa-angle-up').addClass('fa-angle-down');
			$('.stationDropdown').removeClass('state--open').addClass('state--closed');
			$('.station__details').removeClass('state--open').css('position', 'static');
		}
	},
	initErrorHandling: function() {
		var $form = $('#carwaySearch');
		$form.find('input, select').on('change', function() {
			var $element = $(this),
				$elm = $element.parents('.elm');
			$elm.find('ul.errors').hide();
			$elm.removeClass('invalid');
		});
	},
	initStationDropdown: function() {
		carway.stationDropdown.init($('input.hasStationDropdown'));
	},
	initDatepicker: function() {
		carway.datePicker.init('.elm_PickupDate .datepicker');
		carway.datePicker.option('.elm_PickupDate .datepicker', 'onClose', carway.datePicker.populate);
		carway.datePicker.init('.elm_ReturnDate .datepicker');
		carway.datePicker.option('.elm_ReturnDate .datepicker', 'onClose', carway.datePicker.populate);

		var $pickupDate = $('#pickupDate');
		var $pickupTime = $('#pickupTime');
		var $returnDate = $('#returnDate');
		var $returnTime = $('#returnTime');

		$pickupDate.datepicker('option', 'onSelect', function() {
			$(this).closest('.elm').removeClass('invalid').find('ul.errors').hide();
			if (!$pickupTime.val()) {
				setTimeout(function () {
					$pickupTime.timepicker('show');
				}, 300);
			}
		});
		$pickupTime.on('hideTimepicker', function() {
			if (!carway.search.isMobile() && !$returnDate.hasClass('hasOption')) {
				$returnDate.datepicker('show');
			}
		});
		$returnDate.datepicker('option', 'onSelect', function() {
			$returnDate.addClass('hasOption');
			$(this).closest('.elm').removeClass('invalid').find('ul.errors').hide();
			if (!$returnTime.val()) {
				setTimeout(function () {
					$returnTime.timepicker('show');
				}, 300);
			}
		});
	},
	initTimepicker: function(){
		carway.timePicker.init($('input.hasTimepicker'));
	},
	initClockpicker: function() {
		$('input.clockpicker').each(function() {
			var $clockpicker = $(this);

			// Validate station opening hours
			$clockpicker.on('change', function() {
				var $input = $(this),
					type = ($input.attr('id').indexOf('pickup') === 0) ? 'pickup' : 'return',
					stationId = $('#' + type + 'StationId').val(),
					date = $('#' + type + 'Date').val(),
					time = $('#' + type + 'Time').val();

				carway.ajax.validateOpeninghours(stationId, date + ' ' + time, function(r) {
					if (r) {
						if (r.valid) {
							// Remove dialog
							$('#searchOpeningHours').remove();
						}
						else {
							// Create dialog
							var $element = $('#searchOpeningHours'),
								afterHours = (r.afterHours) ? ' ' + r.afterHours : '',
								dialog = '<div id="searchOpeningHours" class="search__notice">'
									+ '<strong>' + r.station.Station + '</strong><br>'
									+ r.openingHours + afterHours + '<br>'
									+ r.notice + '</div>';

							if ($element.length) {
								// Replace dialog
								$element.replaceWith(dialog);
							}
							else {
								// Add dialog
								$('#fieldset-dateTimeReturn').after(dialog);
							}
						}
					}
				});
			});
		});
	}
};

carway.timePicker = {
	init: function($inputs) {
		$inputs.each(function() {
			var $input = $(this);

			$input.timepicker({
				timeFormat: 'H:i',
				scrollDefault: 'now',
				forceRoundTime: true,
				orientation: 'tr',
				disableTimeRanges: [
					['00:00', '23:59']
				],
				disableTouchKeyboard: true,
			});
		});

	},

	// Set timePicker option
	option: function(selector, option, value) {
		$(selector).timepicker('option', option, value);
	},

	// Clear timePicker
	clear: function(selector) {
		$(selector).timepicker('setTime', undefined);
	},

	setOpeningHours: function(type, stationId, date) {
		// Update opening hours in time pickers
		carway.ajax.getOpeningHours(stationId, date, function(result) {
			if (!result || result.length === 0) {
				result = ['23:59', '23:59'];
			}

			if (type === 'pickup') {
				carway.timePicker.setAllowedTimeRange('#pickupTime', result[0], result[1]);
			}
			else {
				carway.timePicker.setAllowedTimeRange('#returnTime', result[0], result[1]);
			}
		});
	},

	setAllowedTimeRange: function(selector, from, to) {
		if (selector && from && to) {
			var intFrom = parseInt(from.replace(':', '')),
				intTo = parseInt(to.replace(':', ''));

			if (intFrom > intTo) {
				// to goes past midnight for selected day
				$(selector).timepicker('option', 'disableTimeRanges', [[to, from]]);
			}
			else {
				$(selector).timepicker('option', 'disableTimeRanges', [['00:00', from],[to, '23:59']]);
			}
		}
	}
};

carway.datePicker = {
	init: function(selector) {
		var $input = $(selector);

		let numberOfMonths = 2;

		if ($(window).width() < 768) {
			numberOfMonths = 1;
		}

		$input.datepicker({
			dateFormat: 'dd.mm.yy',
			minDate: 0,
			numberOfMonths: numberOfMonths,
			constrainInput: true,
			//changeMonth: true,
			//changeYear: true
		});

		if ($input.val()) {
			carway.datePicker.populate($input.val());
		}
	},

	// Set datepicker option
	option: function(selector, option, value) {
		$(selector).datepicker('option', option, value);
	},

	populateReturn: function(date)
	{
		// date must be formatted dd.mm.yyyy
		if (date.match(/^(0?[1-9]|[12][0-9]|3[01])[.](0?[1-9]|1[012])[.]\d{4}$/)) {
			var $returnDate = $('#returnDate'),
				dateString = '',
				dateBits = date.split('.'),
				pickupDate = new Date(dateBits[2], dateBits[1] - 1, dateBits[0]),
				returnDate = $returnDate.datepicker('getDate'),
				minimumReturnDate = pickupDate,
				defaultReturnDate = new Date((minimumReturnDate.getTime() / 1000 + 60 * 60 * 24 * 1) * 1000);

			if (!returnDate) {
				// No return date set so we use the default
				$returnDate.datepicker('setDate', defaultReturnDate);
				dateString = defaultReturnDate.getDate() + '.'
					+ (parseInt(defaultReturnDate.getMonth()) + 1) + '.'
					+ defaultReturnDate.getFullYear();
			}
			else if (returnDate < minimumReturnDate) {
				// Return date is set to a date before pickup date
				$returnDate.datepicker('setDate', minimumReturnDate);
				dateString = minimumReturnDate.getDate() + '.'
					+ (parseInt(minimumReturnDate.getMonth()) + 1) + '.'
					+ minimumReturnDate.getFullYear();
			}

			if (dateString.length) {
				// Update timepicker with opening hours
				carway.timePicker.setOpeningHours('return', $('#returnStationId').val(), dateString);
			}

			// Never let return date be before pickup date
			$returnDate.datepicker('option', {
				minDate: pickupDate
			});
		}
	},

	// Populate returnDate based on date given
	populate: function(date) {
		if (date) {
			var $input = $(this);

			// Update timepicker when selecting date
			var type = ($input.attr('name') === 'pickupDate') ? 'pickup' : 'return',
				stationId = $('#' + type + 'StationId').val();

			if (type === 'pickup') {
				carway.datePicker.populateReturn(date);
			}

			carway.timePicker.setOpeningHours(type, stationId, date);
		}
	}
};

carway.stationDropdown = {
	content: null,
	init: function($inputs) {
		carway.stationDropdown.initStations(function(){
			$inputs.each(function(){
				var $input = $(this),
					id = $input.attr('id'),
					$valueElement = null;

				// Set the input to the selected station
				if (id.length) {
					var valueId = id + 'Id';
					$valueElement = $('#'+valueId);
					var $selected = $valueElement.find(':selected');
					if ($selected.length && $selected.val()) {
						$input.val($selected.attr('label'));
					}
				}

				if ($input.length) {
					carway.stationDropdown.create($input);
				}

				// Update timepicker
				var type = ($input.attr('name') === 'pickupStation') ? 'pickup' : 'return',
					stationId = $('#' + type + 'StationId').val(),
					date = $('#' + type + 'Date').val();
				carway.timePicker.setOpeningHours(type, stationId, date);
			});
		});
		carway.stationDropdown.bodyClickHandler();
	},
	initStations: function(callback) {
		if (!carway.stationDropdown.content) {
			$.ajax({
				url: carway.buildUrl('/moya/carway/ajax/stations')
			}).done(function(html) {
				carway.stationDropdown.content = html;
				callback();
			});
		}
		else {
			callback();
		}
	},
	create: function($input) {
		var type = ($input.attr('name') === 'pickupStation') ? 'pickup' : 'return';

		var $dropdown = $('<div class="stationDropdown state--closed">' +
			'<div class="stationDropdown__content">' + carway.stationDropdown.content + '</div>' +
			'</div>');

		// Handle clicks on input
		$input.on('click', function() {
			carway.stationDropdown.clickHandler($dropdown);
		});

		let dropdownFun = carway.search.isMobile() ? 'click' : 'hover';
		let stationBtn = carway.search.isMobile() ? '.station__button' : '.station__button--link';
		// Handle clicks on drowdown button
		$dropdown.find('.stationDropdown__button').on('click', function() {
			carway.stationDropdown.clickHandler($dropdown);

			// Open the form if its closed
			var $form = $('#carwaySearch').parent('.searchForm');
			if (!$form.hasClass('state--open')) {
				$('.searchForm__trigger').trigger('click');
			}
		});

		// Handle show of station
		$dropdown.find('.station__button--link').on(dropdownFun, function(e) {
			e.preventDefault();

			var	$button = $(this),
				id = $button.attr('href'),
				$dropdown = $button.parents('.stationDropdown__content'),
				$content = $dropdown.find(id);

			var doOpen = !$content.hasClass('state--open');

			if (carway.search.isMobile() || doOpen) {
				$('.station__details').removeClass('state--open').css('position', 'static');
			}

			if (doOpen) {
				$content.addClass('state--open');
				if (!carway.search.isMobile()) {
					$content.css('position', 'absolute');
				}
			}
			carway.iframe.height();
		});

		// Handle selection of station
		$dropdown.find(stationBtn).on('click', function(e) {
			e.preventDefault();

			var $button = $(this),
				date = '',
				id = $button.attr('data-stationId'),
				title = $button.attr('data-stationTitle');

			if (!id) {
				id = $button.href.replace('#station-', '');
			}

			if (!title) {
				title = $button.html();
			}

			// Set station title
			$input.val(title).trigger('change');

			// Set station id
			var $returnStationId = $('#returnStationId');
			if (type === 'pickup') {
				$('#pickupStationId').val(id);

				if (!$returnStationId.val() || $('#sameReturnAsPickup').is(':checked')) {
					// Set return station as the same as pickup
					$returnStationId.val(id);
					$('#returnStation').val(title).trigger('change');
				}
			}
			else {
				$returnStationId.val(id);
			}

			// Update timepicker when selecting station
			date = $('#' + type + 'Date').val();
			if (date) {
				carway.timePicker.setOpeningHours(type, id, date);
			}

			$('body').removeClass('state-dropdown--opened');
			$('.stationDropdown').removeClass('state--open').addClass('state--closed');
			// Stop autofocusing date. It breaks layout when using widget
			//$('#elm_pickupDate .lmnt input').trigger('focus');
			$('.station__details').removeClass('state--open').css('position', 'static');

			// Close the window
			//$dropdown.find('.stationDropdown__button').trigger('click');
		});

		$input.after($dropdown);
	},
	clickHandler: function($dropdown) {
		$('.stationDropdown').not($dropdown).removeClass('state--open').addClass('state--closed');
		if ($dropdown.length) {
			if ($dropdown.hasClass('state--closed')) {
				$dropdown.removeClass('state--closed');
				$dropdown.addClass('state--open');
				$('body').addClass('state-dropdown--opened');

				// Open the first one on desktop
				if (!carway.search.isMobile()) {
					$dropdown.find('.station__link:first').trigger('click');
				}
			}
			else {
				$dropdown.removeClass('state--open');
				$dropdown.addClass('state--closed');
				$('body').removeClass('state-dropdown--opened');
				$('.station__details').removeClass('state--open');
			}
		}
		carway.iframe.height();
	},

	bodyClickHandler: function() {
		$('#carwaySearch').on('click', (e) => {
			e.stopPropagation();
		});
		var $body = $('body');
		$body.on('click', () => {
			if ($body.hasClass('state-dropdown--opened')) {
				$('.stationDropdown.state--open').closest('.elm').find('.hasStationDropdown').trigger('click');
			}
		});
		$(document).keyup(function (e) {
			if (e.key === 'Escape' && $body.hasClass('state-dropdown--opened')) {
				$('.stationDropdown.state--open').closest('.elm').find('.hasStationDropdown').trigger('click');
			}
		});
	}
};

carway.ui = {
	dialog: function() {
		$('a.dialog', '#carway').on('click', function(e) {
			e.preventDefault();

			var $a = $(this),
				id = $a.attr('href');

			if (id) {
				$(id).dialog();
			}
		});
	},
	floats: function() {
		$(document).scroll(function() {
			var $floater = $('.section--floats', '#carway');
			if ($floater.length) {
				var scrollTop = $(document).scrollTop(),
					offset = parseInt($floater.offset().top);

				if (offset < scrollTop && !$floater.hasClass('section--floating')) {
					// The element is not floating ad is leaving screen at top. Float it!
					$floater.attr('data-offsetTop', offset);
					$floater.css('width', $floater.width() + 'px');
					$floater.addClass('section--floating');
				}
				else if ($floater.attr('data-offsetTop') && $floater.hasClass('section--floating')) {
					// The element is floating. Stop it!
					if ($floater.attr('data-offsetTop') > scrollTop) {
						// Element should stop floating since top of screen is above original position
						$floater.removeClass('section--floating');
						$floater.removeAttr('data-offsetTop');
						$floater.css('width', '100%');
					}
				}
			}
		});

	},
	buttons: function() {
		var $form = $('#carwaySearch');
		$form.submit((e) => {
			if (this.validateForm($form)) {
				var $button = $form.find('#search');

				// Create a new button
				var $a = $('<a>');
				$a.attr('href', $button.attr('href'));
				$a.attr('class', $button.attr('class'));
				$a.attr('id', $button.attr('id'));
				$a.html('<i class="fa fa-spinner fa-spin"></i> ' + $button.val());
				$a.addClass('btn--loading');

				// Hide submit input and show dummy button with spinner
				$button.hide();
				$button.after($a);
			}
			else {
				e.preventDefault();
			}
		});
	},

	validateForm: function($form, addError = true) {
		var validated = true;
		$form.find('[aria-required="true"]').each((i, el) => {
			var $element = $(el);
			if (el.type === 'radio' || el.classList.contains('hide')) {
				return;
			}
			if (el.name === 'driverAge' || el.name === 'driverCountry') {
				return;
			}
			if ($element.val() === '') {
				validated = false;
				if (addError) {
					$element.closest('.elm').addClass('invalid');
				}

			}
		});
		return validated;
	},

	searchVehicle: function() {
		$('a.vehicle__search').on('click', function(e) {
			e.preventDefault();
			var $form = $('#carwaySearch');

			if ($form && carway.ui.validateForm($form, false)) {
				var $a = $(this),
					$vehicleElm = $form.find('#vehicle');
				$vehicleElm.val($a.attr('data-vehicleGroup'));
				$form.submit();
			}
			else {
				window.location = $(this).attr('href');
			}
		})
	},

	selectVehicle: function() {
		$('.price__button', '.entry__prices').on('click', function(e) {
			e.stopPropagation();
			e.preventDefault();

			var $button = $(this),
				$form = $('#carwayVehiclesForm'),
				$select = $form.find('#vehicle'),
				$rc = $form.find('#rc'),
				$cc = $form.find('#cc')
			;

			$select.val($button.attr('data-vehicleGroup'));
			$rc.val($button.attr('data-rc'));
			$cc.val($button.attr('data-cc'));
			$form.submit();
		});

		const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
			const { top, left, bottom, right } = el.getBoundingClientRect();
			const { innerHeight, innerWidth } = window;
			return partiallyVisible
				? ((top > 0 && top < innerHeight) ||
					(bottom > 0 && bottom < innerHeight)) &&
				((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
				: top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
		};

		var selected = document.querySelector('.entry--selected');
		if (selected && !elementIsVisibleInViewport(selected)) {
			setTimeout(() => {
				selected.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}, 400);
		}
	},
	tabs: function() {
		let $vehicletabs = $('#vehicletabs');
		if ($vehicletabs.length) {
			var $container = $vehicletabs.tabs();
			// Select a tab based on selected category
			var index = $('.category--selected', '#vehicletabs').index();
			if (index > 0) {
				$container.tabs("option", "active", index);
			}
		}

		$('div.tabs', '#carway').tabs();

		// Unbind tabs that have noAjax class
		// Used to allow tabs to be a link
		$('a.ui-tabs-noAjax', '#carway').unbind('click');
	},
	accordion: function() {
		$('.subform > legend').each(function() {
			var $legend = $(this),
				$subform = $legend.parent('.subform');

			$legend.on('click', function() {
				if ($subform.hasClass('state--open')) {
					$subform.removeClass('state--open').addClass('state--closed');
				}
				else {
					$subform.removeClass('state--closed').addClass('state--open');
				}
			});
		})
	},
	boolean: function() {
		$('.boolean', '#carway').each(function() {
			var $this = $(this),
				state = false;

			// Set value from parameter
			if ($this.attr('data-value') > 0) {
				$this.addClass('state--set');
			}

			$this.on('click', function(e) {
				e.preventDefault();

				if ($this.hasClass('state--disabled')) {

				}
				else {
					if ($this.hasClass('state--set')) {
						$this.removeClass('state--set');
						state = 0;
					}
					else {
						$this.addClass('state--set');
						state = 1;
					}

					$('#' + $this.attr('data-type') + '-' + $this.attr('data-extraid')).val(state);
				}

				carway.extras.parseSelection($this);
			});

			$this.on('setStateDisabled', function() {
				$this.removeClass('state--set');
				$this.addClass('state--disabled');
				$('#extras-'+$this.attr('data-extraid')).val(0);
			});

			$this.on('setStateEnabled', function() {
				$this.removeClass('state--disabled');
			});
		});
	},
	quantity: function() {
		$('.quantity', '#carway').each(function() {
			var $this = $(this),
				$value = $this.find('.quantity__value'),
				$increase = $this.find('.quantity__increase'),
				$decrease = $this.find('.quantity__decrease'),
				maxAllowed = 3;

			// Set value from parameter
			if ($this.attr('data-value') > 0) {
				$value.html($this.attr('data-value'));
				$decrease.removeClass('state--disabled');
				$this.addClass('state--set');
			}

			$increase.on('click', function(e) {
				e.preventDefault();
				e.preventDefault();
				var value = parseInt($this.attr('data-value')) + 1;

				// Don't go over maximum allowed
				if (value > maxAllowed) {
					return;
				}

				if (value === maxAllowed) {
					$increase.addClass('state--disabled');
				}
				else {
					$increase.removeClass('state--disabled');
					$this.addClass('state--set');
				}

				$this.attr('data-value', value);
				$value.html(value);

				$decrease.removeClass('state--disabled');

				$('#extras-'+$this.attr('data-extraid')).val(value);
				carway.extras.parseSelection($this);
			});

			$decrease.on('click', function(e) {
				e.preventDefault();
				var value = parseInt($this.attr('data-value')) - 1;

				if (value > -1) {
					$this.attr('data-value', value);
					$value.html(value);
				}

				if (value === 0) {
					$decrease.addClass('state--disabled');
					$this.removeClass('state--set');
				}

				$increase.removeClass('state--disabled');

				$('#extras-'+$this.attr('data-extraid')).val(value);
				carway.extras.parseSelection($this);
			});
		});
	},
	tos: function() {
		$('.tos__toggle').on('click', function(e) {
			e.preventDefault();

			var $trigger = $(this),
				$tos = $trigger.parents('.tos');

			$tos.toggleClass('state--open');
		});
	}
};

carway.extras = {
	relation: {
		'ALL': ['PREMI', 'MEDIU', 'SCDW', 'SADW', 'GP'],
		'PREMI': ['MEDIU', 'SCDW', 'SADW', 'GP'],
		'MEDIU': ['PREMI', 'SCDW', 'GP'],
		'SCDW': ['MEDIU', 'PREMI'],
		'GP': ['MEDIU', 'PREMI'],
		'SADW': ['PREMI']
	},
	parseSelection: function($clicked) {
		var $container = $('#extras'),
			elementsToDisable = undefined;

		// Only do this if the element we clicked on is active
		if (!$clicked || !$clicked.hasClass('state--disabled')) {
			// Go through selected extras
			$container.find('div.boolean.state--set, div.quantity.state--set').each(function() {
				var $selected = $(this);
				// Check if selected extra has relation
				if (carway.extras.relation[$selected.attr('data-extraid')]) {
					if (!elementsToDisable) {
						elementsToDisable = carway.extras.relation[$selected.attr('data-extraid')];
					}
					else {
						elementsToDisable = elementsToDisable.concat(carway.extras.relation[$selected.attr('data-extraid')]);
					}
				}
			});

			// Go through all the extras and disable if there is relation
			$container.find('div.boolean, div.quantity').each(function () {
				var $extra = $(this);
				if (elementsToDisable && elementsToDisable.indexOf($extra.attr('data-extraid')) !== -1) {
					$extra.trigger('setStateDisabled');
				}
				else {
					$extra.trigger('setStateEnabled');
				}
			});

			// Submit current form state
			carway.ajax.extra();
		}
	}
};

carway.iframe = {
	lastUpdated: 0,

	height: function() {
		var now = new Date().getTime();
		if (carway.iframe.lastUpdated === 0 || now - carway.iframe.lastUpdated > 100) {
			carway.iframe.lastUpdated = now;
			parent.postMessage("height::" + $('body').outerHeight(), "*");
		}
	}
};

carway.ajax = {
	updateCart: function() {
		$.ajax({
			method: 'get',
			url: '/moya/carway/ajax/updatecart'
		}).done(function (r) {
			$('#carwayCart').replaceWith(r);

			// Trigger the scroll event to update floater position
			$(document).trigger('scroll');
		});
	},

	extra: function() {
		$.ajax({
			method: 'post',
			url: carway.buildUrl('/moya/carway/ajax/extra'),
			data: $('#carwayExtrasForm').serializeArray()
		}).done(function (r) {
			$('#carwayCart').replaceWith(r);

			// Trigger the scroll event to update floater position
			$(document).trigger('scroll');
		});
	},

	getOpeningHours: function(stationId, date, callback) {
		if (stationId && date) {
			$.ajax({
				method: 'get',
				url: carway.buildUrl('/moya/carway/ajax/getopeninghours'),
				data: {
					'stationId': stationId,
					'date': date
				}
			}).done(function (r) {
				callback(r);
			});
		}
	},

	validateOpeninghours: function(stationId, date, callback) {
		$.ajax({
			method: 'get',
			url: carway.buildUrl('/moya/carway/ajax/validateopeninghours'),
			data: {
				'stationId': stationId,
				'date': date
			}
		}).done(function (r) {
			callback(r);
		});
	}
};
carway.datetime = {
	forceUTC: true,
	locale: null,
	init: function() {
		if (Intl && Intl.DateTimeFormat) {
			carway.datetime.detectLocale();
			carway.datetime.formatAll();
		}
	},
	formatAll: function () {
		$('time[data-format]').each(function() {
			carway.datetime.format(this);
		});
	},
	detectLocale: function(){
		if (moya && moya.lang && moya.lang === 'is') {
			carway.datetime.locale = 'is-IS';
		}
		else {
			carway.datetime.locale = window.navigator.language;
		}
	},
	format: function(element) {
		var $this = $(element);
		var format = $this.data('format');
		var date = new Date($this.attr('datetime'));
		var opts = carway.datetime.createOpts(format, carway.datetime.locale);
		var dateFormatter = new Intl.DateTimeFormat(carway.datetime.locale, opts);
		var ret = dateFormatter.format(date);
		$this.text(ret);
	},
	createOpts: function(format, locale) {
		var ret = {};
		if (locale !== 'is-IS') {
			ret.timeZoneName = 'short';
			ret.timeZone = 'UTC';
		}
		if (carway.datetime.forceUTC) {
			ret.timeZone = 'UTC';
		}
		var chars = format.split('');
		for (var i = 0, c = chars.length; i < c; ++i) {
			var char = chars[i];
			switch (char) {
				case 'd':
					ret.day = '2-digit';
					break;
				case 'j':
					ret.day = 'numeric';
					break;
				case 'D':
					ret.weekDay = 'short';
					break;
				case 'l':
					ret.weekDay = 'long';
					break;
				case 'm':
					ret.month = '2-digit';
					break;
				case 'n':
					ret.month = 'numeric';
					break;
				case 'F':
					ret.month = 'long';
					break;
				case 'M':
					ret.month = 'short';
					break;
				case 'Y':
					ret.year = 'numeric';
					break;
				case 'y':
					ret.year = '2-digit';
					break;
				case 'h':
				case 'H':
					ret.hour = 'numeric';
					break;
				case 'i':
					ret.minute = 'numeric';
					break;
				case 's':
					ret.second = 'numeric';
					break;
				default:
					break;
			}
		}
		return ret;
	}
};

$(function() {
	carway.ui.accordion();
	carway.ui.tabs();
	carway.ui.boolean();
	carway.ui.quantity();
	carway.ui.buttons();
	carway.ui.floats();
	carway.ui.dialog();
	carway.ui.searchVehicle();
	carway.ui.selectVehicle();
	carway.ui.tos();
	carway.search.initForm();
	carway.extras.parseSelection(null);

	carway.iframe.height();
	window.addEventListener('resize', carway.iframe.height);
	window.addEventListener('click', carway.iframe.height);
	setTimeout(function() {
		$('body').trigger('resize');
	}, 1000);

	if (moya.lang !== 'is') {
		carway.datetime.init();
	}
});
